export default __webpack_public_path__ + "static/media/asraLogo3.2e849103.png";